/**
 * SmartConnect Style01 - Connect button
 */
import type { TraitControlProps } from './types'

export function SmartConnectStyle01({
  onCommand,
  disabled = false,
}: TraitControlProps) {
  return (
    <div className="smart-home-automation-field">
      <label>SmartConnect</label>
      <button
        type="button"
        className="smart-home-automation-command-btn glass"
        onClick={() => onCommand('connect', {})}
        disabled={disabled}
      >
        <span className="material-symbols-outlined">link</span>
        Connect
      </button>
    </div>
  )
}
